// extracted by mini-css-extract-plugin
export var cardCTA = "CardCTA-module--cardCTA--47d08";
export var icon = "CardCTA-module--icon--a21c6";
export var recommended = "CardCTA-module--recommended--6e313";
export var redirect = "CardCTA-module--redirect--4903f";